import React, { useState, useEffect } from "react";
import MainHeader from "./MainHeader";
import Sidebar from "./Sidebar";
import axios from "axios";
import { Table, Container, Spinner, OverlayTrigger, Popover } from "react-bootstrap";
import Split from "react-split";
import { BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { VscVmActive } from "react-icons/vsc";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ProgressBar } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { PiWarningCircleFill } from "react-icons/pi";

const Capacity = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [show, setShow] = useState(false);
  const [selectedFamilyRequest, setSelectedFamilyRequest] = useState("");
  const [limitRequest, setLimitRequest] = useState("");
  const [targetAvailableCors, setTargetAvailableCors] = useState("");
  const [targetUsage, setTargetUsage] = useState("");
  const [prevUsage, setPrevUsage] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [requestId, setRequestId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // const handleShows = (family) => {
  //   setShows(true);
  //   setSelectedFamily(family);
  // }
  console.log("requestId", requestId);
  const handleClose = () => {
    setShow(false);
    setErrorMessage("");
  };

  const handleLimitChange = (event) => {
    const value = event.target.value;
    setLimitRequest(value === "" ? "" : parseFloat(value)); // Convert to number if not empty
    setErrorMessage("");
  };

  const handleRequestClick = () => {
    if (!limitRequest || isNaN(limitRequest) || Number(limitRequest) <= 0) {
      setErrorMessage("Please give a limit");
      return;
    }
    handleSendRequest(); // Proceed if valid
  };

  const handleSendRequest = async () => {
    const limits = limitRequest + Number(targetAvailableCors);
    const payLoad = {
      subscriptionId: "d6240a3c-34a4-4a5c-955b-06228bf34ca8",
      limit: limits,
      vmFamilyType: selectedFamilyRequest,
      location: selectedRegion,
    };
    // const payLoad = {
    //   subscriptionId:"d6240a3c-34a4-4a5c-955b-06228bf34ca8",
    //   limit:"11",
    //   vmFamilyType:"standardBSFamily",
    //   location:"centralus"
    // }
    try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/cloud/AZURE/request-quota`,
      payLoad
    );
    if (response.status === 200 && response.data.status === "Success") {
      setIsLoader(true);
      setLimitRequest("");
      toast.success("Request has been sent to increase the vCPU core");
      const requestId = response?.data?.data?.id;
      setRequestId(requestId);

      const intervalId = setInterval(async () => {
        try {
          const simultaneousResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/cloud/azure/verify-quota-request?id=${requestId}`
          );
          console.log(
            "simultaneousResponse",
            simultaneousResponse?.data?.data?.properties?.provisioningState ===
              "Succeeded"
          );

          const provisioningState =
            simultaneousResponse?.data?.data?.properties?.provisioningState ===
            "Succeeded";

          if (provisioningState) {
            setIsLoader(false);
            capacityPlan(); // Call the capacity plan function once the state is "Succeeded"

            // Stop the interval once the condition is met
            clearInterval(intervalId);
          }
        } catch (error) {
          console.error("Error fetching data", error);
        }
      }, 20000); // Run every 20 seconds
    }
    if (response.data.status === "failed") {
      toast.error(response?.data?.data?.error?.message);
    }
  } catch (error) {
    console.error("error", error);
    toast.error(error?.response?.data?.message);
  }
    setShow(false);
  };
  const handleShow = (location, family, core, vcpu, prevUse) => {
    setShow(true);
    setSelectedFamilyRequest(family);
    setTargetAvailableCors(core);
    setTargetUsage(vcpu);
    setPrevUsage(prevUse);
  };


  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };
  const regions = [
    { value: "eastus", label: "East US" },
    { value: "eastus2", label: "East US 2" },
    { value: "westus", label: "West US" },
    { value: "centralus", label: "Central US" },
    { value: "northcentralus", label: "North Central US" },
    { value: "southcentralus", label: "South Central US" },
    { value: "northeurope", label: "North Europe" },
    { value: "westeurope", label: "West Europe" },
    { value: "eastasia", label: "East Asia" },
    { value: "southeastasia", label: "Southeast Asia" },
    { value: "japaneast", label: "Japan East" },
    { value: "japanwest", label: "Japan West" },
    { value: "australiaeast", label: "Australia East" },
    { value: "australiasoutheast", label: "Australia Southeast" },
    { value: "australiacentral", label: "Australia Central" },
    { value: "brazilsouth", label: "Brazil South" },
    { value: "centralindia", label: "Central India" },
    { value: "westindia", label: "West India" },
    { value: "canadacentral", label: "Canada Central" },
    { value: "canadaeast", label: "Canada East" },
    { value: "westus2", label: "West US 2" },
    { value: "westcentralus", label: "West Central US" },
    { value: "uksouth", label: "UK South" },
    { value: "ukwest", label: "UK West" },
    { value: "koreacentral", label: "Korea Central" },
    { value: "koreasouth", label: "Korea South" },
    { value: "francecentral", label: "France Central" },
    { value: "southafricanorth", label: "South Africa North" },
    { value: "southindia", label: "South India" },
    { value: "uaenorth", label: "UAE North" },
    { value: "switzerlandnorth", label: "Switzerland North" },
    { value: "germanywestcentral", label: "Germany West Central" },
    { value: "norwayeast", label: "Norway East" },
    { value: "jioindiawest", label: "Jio India West" },
    { value: "westus3", label: "West US 3" },
    { value: "swedencentral", label: "Sweden Central" },
    { value: "qatarcentral", label: "Qatar Central" },
    { value: "polandcentral", label: "Poland Central" },
    { value: "italynorth", label: "Italy North" },
    { value: "israelcentral", label: "Israel Central" },
    { value: "spaincentral", label: "Spain Central" },
    { value: "mexicocentral", label: "Mexico Central" },
    { value: "newzealandnorth", label: "New Zealand North" },
  ];

  const sortedRegions = regions
    .slice()
    .sort((a, b) => a.label.localeCompare(b.label));

  const [leftData, setLeftData] = useState([]);
  // eslint-disable-next-line
  const [leftWidth, setLeftWidth] = useState(100);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [dropDown, setDropDown] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(regions[3]?.value);
  const [vmDetails, setVmDetails] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);
  const [openRows, setOpenRows] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [showPopUp, setShowPopup] = useState(false);

  const handleClick = () => setShowPopup(!showPopUp);

  const fetchData = async (groupName = null) => {
    console.log(groupName, "Selected Group");

    setLoading(true); // Start loading
    try {
      const subscriptionId = "d6240a3c-34a4-4a5c-955b-06228bf34ca8";
      const filters = groupName ? JSON.stringify(groupName) : ""; // Use filters only if a specific group is selected
      console.log(filters, "Encoded Group Name");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/cloud/azure/capacity-planning/resources`,
        {
          params: {
            top: 10,
            resourceGroup: groupName? groupName?.resourceGroup : "",
            subscriptionId,
            computeServiceChecked: true
            // functionAppChecked: true,
            // appServicesChecked: true,
          },
        }
      );

      if (response.data?.status === "Success") {
        const data = response.data.data.data.computeService;
        if (groupName) {
          // setLoading(false);
          setLeftData(data);
          setVmDetails(
            data.filter(
              (item) => item.type === "Virtual Machine"
            )
          );
        }

        if (!groupName) {
          setDropDown(data); // Update dropdown options

          // Get unique group names
          const uniqueGroupNames = [
            ...new Set(data?.map((item) => item.resourceGroup || "Unnamed")),
          ];
          if (uniqueGroupNames) {
            // Set the first unique group name as the default
            console.log(uniqueGroupNames, "uniqueGroupNames");
            const defaultGroupName = uniqueGroupNames[0];
            setSelectedValue(defaultGroupName);

            // Trigger fetch for the default selection
            fetchData({ resourceGroup: defaultGroupName });
            setLoading(true);
            // capacityPlan();
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    //  finally {
    //   setLoading(false); // Stop loading
    // }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (vmDetails?.length > 0) {
      capacityPlan();
    }
    // eslint-disable-next-line
  }, [vmDetails, selectedRegion, selectedValue]);

  // Handle dropdown value change
  // const handleSelectChange = (event) => {
  //   const value = event.target.value;
  //   console.log(value, "val");

  //   const objVal = {
  //     resourceGroup: value,
  //   };
  //   setSelectedValue(value);
  //   fetchData(objVal); // Call with the selected groupName
  // };

  const handleSelectChanges = (selectedOption) => {
    const value = selectedOption.value;

    const objVal = {
      resourceGroup: value,
    };
    setSelectedValue(value);
    fetchData(objVal); // Call with the selected groupName
  };

  // Generate unique options with icons
  const options = [
    ...new Set(dropDown?.map((data) => data.resourceGroup || "Unnamed")),
  ].map((uniqueGroupName) => {
    const tagName =
      dropDown?.find((data) => data.resourceGroup === uniqueGroupName)
        ?.resourceGroupTags?.projectName || "Tag-undefined";

    return {
      value: uniqueGroupName,
      label: <div className="d-flex align-items-center">{tagName}</div>,
    };
  });

  // const handleRegionChange = (event) => {
  //   setSelectedRegion(event.target.value);
  // };

  const handleRegionChangeSearch = (selectedOption) => {
    setSelectedRegion(selectedOption.value); // Set the selected region
  };

  // const sizeBasedVMs = Object.values(
  //   vmDetails.reduce((acc, item) => {
  //     const { vmSize, name } = item;
  //     if (!acc[vmSize]) {
  //       acc[vmSize] = { vmSize, name: [] };
  //     }
  //     acc[vmSize].name.push(name);
  //     return acc;
  //   }, {})
  // );

  const sizeBasedVMs = [
    ...Object.values(
      vmDetails.reduce((acc, item) => {
        const { computeInstanceSize, platFormName, availabilityZone, name } = item;
  
      // Check if availabilityZone is "N/A" and set it to an empty string
      let parsedAvailabilityZone = availabilityZone === "N/A" ? "" : availabilityZone;

      // If availabilityZone is not "N/A", try parsing it
      if (parsedAvailabilityZone !== "") {
        try {
          const parsedArray = JSON.parse(parsedAvailabilityZone);
          parsedAvailabilityZone = Array.isArray(parsedArray) ? parsedArray[0] : parsedAvailabilityZone;
        } catch (error) {
          // If parsing fails, keep the original value
          parsedAvailabilityZone = availabilityZone;
        }
      }

        // Create a unique key combining vmSize, platformName, and availabilityZone
        const key = `${computeInstanceSize}-${platFormName}-${availabilityZone}`;
  
        if (!acc[key]) {
          acc[key] = { computeInstanceSize, platFormName, availabilityZone: parsedAvailabilityZone, computeInstanceName: [] };
        }
        
        acc[key].computeInstanceName.push(name); // Add the name to the grouped object
  
        return acc;
      }, {})
    ),
    // {
    //   name: ["vm1-DR", "vm2-DR"],
    //   vmSize: "Standard_M64bds_1_v3",
    // },
  ];

  const capacityPlan = async () => {
    setLoading(true); // Start loading

    // Collect relevant data from the leftData based on the selected resource group
    // const selectedGroupData = leftData.filter(
    //   (item) => item.resourceGroup === selectedValue
    // );

    // const sourceVmSizes = selectedGroupData
    //   .filter((item) => item.vmSize !== "N/A")
    //   .map((item) => item.vmSize || ""); // Collect VM sizes

    // const functionAppServerFarmIds = selectedGroupData
    //   .filter((item) =>
    //     [
    //       "functionapp,linux",
    //       "functionapp",
    //       "functionapp,linux,container",
    //       "elastic",
    //     ].includes(item.kind)
    //   )
    //   .map((item) => item.serverFarmId); // Collect Function App Server Farm IDs

    // const webAppServerFarmIds = selectedGroupData
    //   .filter((item) =>
    //     [
    //       "app",
    //       "app,linux",
    //       "app,linux,container",
    //       "app,container",
    //       "mobileapp",
    //       "mobileapp,linux",
    //       "mobileapp,linux,container",
    //       "api",
    //       "api,linux",
    //       "api,linux,container",
    //     ].includes(item.kind)
    //   )
    //   .map((item) => item.serverFarmId); // Collect Web App Server Farm IDs

    const payload = {
      subscriptionId: "d6240a3c-34a4-4a5c-955b-06228bf34ca8",
      sourceResourceInstanceSizes: sizeBasedVMs, // Array of VM sizes
      // functionAppServerFarmIds, // Array of Function App IDs
      // webAppServerFarmIds, // Array of Web App IDs
      targetRegion: selectedRegion, // Set the target region as required
      sourceRegion: vmDetails[0]?.location,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/cloud/AZURE/failover/available-resource-list`,
        payload
      );

      // if (response.status === 200 && response.data) {
      // If the response is an object with multiple lists
      // const { vmCheckList, functionAppCheckList, webAppCheckList } =
      //   response.data.data;

      // Combine all the lists into a single array of resources
      // const combinedResources = [
      //   ...(vmCheckList || []).map((item) => ({ ...item, type: "VM" })),
      //   ...(functionAppCheckList || []).map((item) => ({
      //     ...item,
      //     type: "FunctionApp",
      //   })),
      //   ...(webAppCheckList || []).map((item) => ({
      //     ...item,
      //     type: "WebApp",
      //   })),
      // ];

      // // Update leftData with availability status
      // const updatedLeftData = leftData.map((leftItem) => {
      //   const matchedItem = combinedResources.find((rightItem) => {
      //     const isVmSizeMatch =
      //       rightItem.vmSize && rightItem.vmSize === leftItem.vmSize;
      //     const isServerFarmIdMatch =
      //       rightItem.id && rightItem.id === leftItem.serverFarmId;
      //     return isVmSizeMatch || isServerFarmIdMatch;
      //   });

      //   return matchedItem
      //     ? {
      //         ...leftItem,
      //         available: matchedItem.available, // Update availability status
      //         skuName: matchedItem.sku?.name || leftItem.skuName, // Add sku.name if serverFarmId matches
      //       }
      //     : leftItem;
      // });

      
      const computeResponse = response?.data?.data?.computeServiceCheckedList;
      setResourceDetails(computeResponse);
      // const groupedTypes = computeResponse.filter(
      //   (value, index, self) =>
      //     index === self.findIndex((t) => t.family === value.computeFamily)
      // );

      const groupedData = computeResponse.reduce((acc, item) => {
        const {
          computeFamily,
          familyCoreUsageInSourceRegion,
          familyCoreUsageInTargetRegion,
          familyCoreLimitInTargetRegion,
          isComputeInstanceSizeAvailable,
          platFormName,
          isPlatFormMatch,
          availabilityZone,
          vmRequest,
          isZoneAvailable
        } = item;

        // If the family group doesn't exist, create it
        if (!acc[computeFamily]) {
          acc[computeFamily] = {
            computeFamily,
            familyCoreUsageInSourceRegion: 0,
            familyCoreUsageInTargetRegion: familyCoreUsageInTargetRegion,
            familyCoreLimitInTargetRegion: familyCoreLimitInTargetRegion,
            available: isComputeInstanceSizeAvailable,
            platFormName,
            isPlatFormMatch,
            availabilityZone,
            vmRequest,
            isZoneAvailable
          };
        }

        // Sum the sourceRegion and targetRegion for the family
        acc[computeFamily].familyCoreUsageInSourceRegion +=
          familyCoreUsageInSourceRegion;

        return acc;
      }, {});

      // Convert the accumulator object to an array of grouped data
      const result = Object.values(groupedData);

      setLeftData(result);

      // console.log(combinedResources, "combined resources");
      // }
    } catch (err) {
      console.error(err.message || "Something went wrong");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // const dynamicTypes = (family) => {
  //   if (family === "standardBSFamily") {
  //     return <p>B' family</p>
  //   } else if (family === "standardMIDSMediumMemoryv2Family") {
  //     return <p>M' family</p>
  //   } else if (family === "microsoft.web/sites") {
  //     return <p>Function App</p>
  //   }
  // }

  const toggleNestedTable = (id, family) => {
    setOpenRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // Toggle the visibility for the clicked row
    }));
    setSelectedId(id);
  };
  console.log(selectedId, "selectedId");

  // Calculate required vCPUs (How many more are needed)
  const requiredVCPUs = Number(targetAvailableCors);

  // Total vCPUs after increasing quota
  const totalLimit = Number(prevUsage) + Number(targetUsage);

  // Calculate progress width based on needed vCPUs (fill only needed part)
  const progressValue = (requiredVCPUs / totalLimit) * 100;

  // const flattenedData = resourcesByFamily.flatMap((item) => {
  //   const names = item.name.split(",").map((name) => name.trim());
  //   return names.map((name) => ({
  //     name,
  //     vmSize: item.vmSize,
  //     vCPUs: item.vCPUs,
  //     available: item.available,
  //   }));
  // });

  const flattenedData = (family) => {
    // Get the data filtered by the current family
    const resourcesByFamily = resourceDetails?.filter(
      (item) => item?.computeFamily === family
    );

    return resourcesByFamily.flatMap((item) => {
      const names = item.computeInstanceName.split(",").map((name) => name.trim());
      return names.map((name) => ({
        name,
        vmSize: item?.computeInstanceSize,
        vCPUs: item?.computeCores,
        available: item?.isComputeInstanceSizeAvailable,
        platFormName: item?.platFormName,
        isPlatFormMatch: item?.isPlatFormMatch,
        availabilityZone: item?.availabilityZone,
        isComputeInstanceSizeAvailable: item?.isComputeInstanceSizeAvailable,
        isZoneAvailable: item?.isZoneAvailable,
        sourceComputeZone: item?.sourceComputeZone
      }));
    });
  };


  const renderTable = (data) => (
    <>
      {/* <Table hover className="table table-responsive rounded"> */}
      {/* <thead className="tablebg">
          <tr>
            <>
              <th className="text-uppercase tablebgtext border-top border-bottom ">
                Name
              </th>
              <th className="text-uppercase tablebgtext border-top border-bottom ">
                Type
              </th>
              <th className="text-uppercase tablebgtext border-top border-bottom ">
                Location
              </th>
              <th className="text-center text-uppercase tablebgtext border-top border-bottom">
                Available Status
              </th>{" "}
              <th className="text-center text-uppercase tablebgtext border-top border-bottom">
                Available Size
              </th>
            </>
          </tr>
        </thead> */}
      {/* <tbody>
          {data.length > 0 ? (
            data.map((row, index) => (
              <tr key={index}>
                
                <td className="text-dark border-0 fw-bold ps-2">{row.name}</td>
                <td className="text-dark border-0">{row.type}</td>
                <td className="text-dark border-0">{row.location}</td>
                <td className="text-dark border-0 text-center">
                  {row.available === true ? (
                    <>
                      <BsCheckCircleFill
                        style={{ color: "#59d05d", fontSize: "20px" }}
                      />
                    </>
                  ) : row.available === false ? (
                    <>
                      <BsXCircleFill
                        style={{ color: "#ff646d", fontSize: "20px" }}
                      />
                    </>
                  ) : (
                    "-"
                  )}
                </td>
                <td className="text-dark text-center border-0">
                  {row.available === true ? (
                    <>
                      <span style={{ marginLeft: "8px" }}>
                        {row.skuName || row.vmSize || "-"}{" "}
                      
                      </span>
                    </>
                  ) : row.available === false ? (
                    <>
                      <span style={{ marginLeft: "8px" }}>
                        {row.skuName || "-"} 
                      </span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr className="text-center">
              <td colSpan={4} className="border-0">
                No data available
              </td>
            </tr>
          )}
        </tbody> */}
      {/* </Table> */}

      <Table
        hover
        className="table table-bordered table-responsive rounded mb-0"
      >
        <thead className="tablebg">
          <tr>
            <>
              <th
                rowspan="2"
                scope="rowgroup"
                className="text-uppercase tablebgtext align-middle"
                style={{ border: "3px solid white" }}
              ></th>
              <th
                rowspan="2"
                scope="rowgroup"
                className="text-uppercase tablebgtext align-middle text-center"
                style={{ border: "3px solid white" }}
              >
                VM's Family
              </th>
              <th
                colspan="1"
                scope="colgroup"
                className="text-center text-uppercase tablebgtext"
                style={{ border: "3px solid white" }}
              >
                {vmDetails[0]?.location}
              </th>
              <th
                colspan="2"
                scope="colgroup"
                className="text-center text-uppercase tablebgtext "
                style={{ border: "3px solid white" }}
              >
                {selectedRegion}
              </th>

              <th
                rowspan="2"
                scope="rowgroup"
                className="text-center text-uppercase tablebgtext text-center align-middle"
                style={{ border: "3px solid white" }}
              >
                Availability status
              </th>

              {/* Add Available column */}
            </>
          </tr>
          <tr>
            <th
              scope="col"
              className="text-center"
              style={{ border: "3px solid white" }}
            >
              vCPUs usage
            </th>
            <th
              scope="col"
              className="text-center"
              style={{ border: "3px solid white" }}
            >
              vCPUs usage
            </th>
            <th
              scope="col"
              className="text-center"
              style={{ border: "3px solid white" }}
            >
              vCPUs Limit
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data?.map((row, index) => (
              <React.Fragment key={row.id}>
                <tr key={index}>
                  <td>
                    <span
                      className="d-flex justify-content-center cursor-pointer"
                      onClick={() => toggleNestedTable(index, row.computeFamily)}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "4px",
                          backgroundColor: flattenedData(row?.computeFamily).some(
                            (item) => item.available === false
                          )
                            ? "#ff646d"
                            : "#5cd060", // Green if any item is available, Grey otherwise
                        }}
                      >
                        {openRows[index] ? (
                          <IoIosArrowUp color="white" />
                        ) : (
                          <IoIosArrowDown color="white" />
                        )}
                      </div>

                      {/* {openRows[index] ? <FaMinus /> : <FaPlus />} */}
                    </span>
                  </td>
                  <td className="text-dark text-center">{row?.computeFamily}</td>
                  <td className="text-dark text-center">
                    {row?.familyCoreUsageInSourceRegion ?? "-"}
                  </td>
                  <td className="text-dark text-center">
                    {row?.familyCoreUsageInTargetRegion ?? "-"}
                  </td>
                  <td className="text-dark  text-center">
                    {row?.familyCoreLimitInTargetRegion ?? "-"}
                  </td>
                  <td className="text-dark text-center">
                    {row?.available === true &&
                    Number(row?.familyCoreUsageInSourceRegion) +
                      Number(row?.familyCoreUsageInTargetRegion) <=
                      Number(row?.familyCoreLimitInTargetRegion) ? (
                      <>
                        <BsCheckCircleFill
                          style={{ color: "#59d05d", fontSize: "20px" }}
                        />
                      </>
                    ) : row?.available === false ||
                      flattenedData(row?.computeFamily).some(
                        (item) => item?.available === false
                      ) ? (
                      <>
                        <BsXCircleFill
                          style={{ color: "#ff646d", fontSize: "20px" }}
                        />
                      </>
                    ) : row.available === true &&
                      Number(row.familyCoreUsageInSourceRegion) +
                        Number(row.familyCoreUsageInTargetRegion) >
                        Number(row.familyCoreLimitInTargetRegion) ? (
                      <>
                        {/* <Button
                          className="btn btn-primary rounded-pill"
                          onClick={() =>
                            handleShow(
                              row?.location,
                              row?.family,
                              row?.familyCoreLimitInTargetRegion,
                              row?.familyCoreUsageInTargetRegion,
                              row?.familyCoreUsageInSourceRegion
                            )
                          }
                          size="sm"
                        >
                          Increase vCPUs
                        </Button> */}
                        <button
                          className="btn button-start text-center"
                          type="button"
                          onClick={() =>
                            handleShow(
                              row?.location,
                              row?.computeFamily,
                              row?.familyCoreLimitInTargetRegion,
                              row?.familyCoreUsageInTargetRegion,
                              row?.familyCoreUsageInSourceRegion
                            )
                          }
                          disabled={isLoader} // Disable the button while loading
                        >
                          {isLoader ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              InProgress...
                            </>
                          ) : (
                            "Increase vCPUs"
                          )}
                        </button>
                      </>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
                {openRows[index] && (
                  <tr className="table-custom">
                    <td colSpan={6} className="p-3">
                      <Table
                        hover
                        className="table-responsive border mb-0 rounded childTable "
                      >
                        <thead className="gray-col th-height">
                          <tr>
                            <th
                              scope="rowgroup"
                              className="text-uppercase tablebgtext text-center align-middle text-top"
                            >
                              Name
                            </th>
                            <th
                              scope="rowgroup"
                              className="text-uppercase tablebgtext text-center align-middle text-top"
                            >
                              Size
                            </th>
                            <th
                              scope="rowgroup"
                              className=" tablebgtext text-center align-middle text-top"
                            >
                              vCPUs
                            </th>
                            <th
                              scope="rowgroup"
                              className="text-uppercase tablebgtext text-center align-middle text-top"
                            >
                              Platform
                            </th>
                            <th
                              scope="rowgroup"
                              className="text-uppercase tablebgtext text-center align-middle text-top"
                            >
                              Zone
                            </th>
                            <th
                              scope="rowgroup"
                              className="text-uppercase tablebgtext text-center align-middle text-top"
                            >
                              Availability
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {flattenedData(row?.computeFamily)?.map(
                            (nestedRow, index) => (
                              <tr key={index}>
                                <td className="text-dark text-center bg-white">
                                  {nestedRow?.name}
                                </td>
                                <td className="text-dark text-center bg-white">
                                  {nestedRow?.vmSize}
                                </td>
                                <td className="text-dark text-center bg-white">
                                  {nestedRow?.vCPUs}
                                </td>
                                <td className="text-dark text-center bg-white">
                                  {nestedRow?.platFormName}
                                </td>
                                <td className="text-dark text-center bg-white">
                                  Zone {nestedRow?.sourceComputeZone}
                                </td>
                                <td className="text-dark text-center bg-white">
                                  {nestedRow.isPlatFormMatch && nestedRow?.isComputeInstanceSizeAvailable && nestedRow?.isZoneAvailable ? (
                                    <>
                                      <BsCheckCircleFill
                                        style={{
                                          color: "#59d05d",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </>
                                  ) : (
                                      <div className="d-flex justify-content-center gap-2 align-items-center">
                                        <BsXCircleFill
                                          style={{
                                            color: "#ff646d",
                                            fontSize: "20px",
                                          }}
                                        /> {' '}
                                        <OverlayTrigger
                                          trigger="click"
                                          placement="top"
                                          rootClose
                                          overlay={
                                            <Popover id="popover-basic">
                                              <Popover.Header>
                                                <div className="d-flex align-items-center">
                                                  <span
                                                    className="text-dark ms-1"
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {(() => {
                                                      // Build the error messages dynamically based on conditions
                                                      let errorMessages = [];

                                                      if (!nestedRow.isPlatFormMatch) {
                                                        errorMessages.push("Platform");
                                                      }

                                                      if (!nestedRow.isComputeInstanceSizeAvailable) {
                                                        errorMessages.push("Compute Instance Size");
                                                      }

                                                      if (!nestedRow.isZoneAvailable) {
                                                        errorMessages.push("Zone");
                                                      }

                                                      // Join the errors with 'and' if more than one is false
                                                      if (errorMessages.length > 1) {
                                                        return `${errorMessages.slice(0, -1).join(', ')} and ${errorMessages[errorMessages.length - 1]} doesn't match`;
                                                      }

                                                      // If only one issue, show it directly
                                                      return errorMessages[0] ? `${errorMessages[0]} doesn't match` : "";
                                                    })()}
                                                  </span>
                                                </div>
                                              </Popover.Header>
                                            </Popover>
                                          }
                                        >
                                          <div
                                            onClick={handleClick}
                                            className="cursor-pointer"
                                          >
                                            <PiWarningCircleFill
                                              style={{
                                                color: "#ffcc2a",
                                                fontSize: "20px",
                                              }}
                                            />
                                          </div>
                                        </OverlayTrigger>

                                      </div>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          ) : (
            <tr className="text-center">
              <td colSpan={4} className="">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );

  return (
    <>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader />

        <div className="px-4 mt-4">
          <div className="card mt-2 mb-2 rounded">
            <div className="d-flex justify-content-between align-items-center m-3 mx-4">
              <div className="d-flex">
                <div>
                  <label>Projects</label>
                  {/* <select
                    className="form-select w-100"
                    aria-label="DR-Dashboard Select"
                    value={selectedValue} // Bind to selected value
                    onChange={handleSelectChange}
                  >
                    {[
                      ...new Set(
                        dropDown.map((data) => data.resourceGroup || "Unnamed")
                      ),
                    ].map((uniqueGroupName, index) => {
                      console.log(uniqueGroupName, "uniqueGroupName");

                      const tagName =
                        dropDown.find(
                          (data) => data.resourceGroup === uniqueGroupName
                        )?.resourceGroupTags?.Name || "Tag-undefined";

                      return (
                        <>
                          <SlGlobe></SlGlobe>
                          <option key={index} value={uniqueGroupName}>
                            {tagName} 
                          </option>
                        </>
                      );
                    })}
                  </select> */}
                  <Select
                    value={options.find(
                      (option) => option.value === selectedValue
                    )}
                    onChange={handleSelectChanges}
                    options={options} // Pass the options
                    isSearchable={true} // Enable search functionality
                    placeholder="Select a Resource Group"
                    className="react-select-container menu-width"
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }), // Ensure it's on top
                      menu: (base) => ({
                        ...base,
                        whiteSpace: "nowrap", // Prevents wrapping of individual options
                        overflowX: "hidden", // Hides any x-scroll
                        // width: "max-content", // Allows content to grow without forcing horizontal scroll
                        minWidth: "200px", // Set a reasonable minimum width
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxWidth: "100%", // Ensures the list doesn't exceed the menu width
                        maxHeight: "350px",
                      }),
                    }}
                  />
                </div>
                <div className=" ms-3">
                  <label>Region</label>
                  {/* <select
                    value={selectedRegion}
                    className="form-select w-100"
                    onChange={handleRegionChange}
                    placeholder="Select the Region"
                  >
                    {regions
                      .slice() // Create a copy to avoid mutating the original array
                      .sort((a, b) => a.label.localeCompare(b.label)) // Sort alphabetically by label
                      .map((region, index) => (
                        <option key={index} value={region.value}>
                          {region.label}
                        </option>
                      ))}
                  </select> */}
                  <Select
                    options={sortedRegions} // Pass sorted options
                    value={sortedRegions.find(
                      (region) => region.value === selectedRegion
                    )}
                    onChange={handleRegionChangeSearch} // Handle selection
                    isSearchable={true} // Enable search
                    placeholder="Select the Region"
                    className="react-select-container menu-width"
                    getOptionLabel={(e) => e.label} // Ensure labels are shown correctly
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }), // Ensure it's on top
                      menu: (base) => ({
                        ...base,
                        whiteSpace: "nowrap", // Prevents wrapping of individual options
                        overflowX: "hidden", // Hides any x-scroll
                        // width: "max-content", // Allows content to grow without forcing horizontal scroll
                        minWidth: "200px", // Set a reasonable minimum width
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxWidth: "100%", // Ensures the list doesn't exceed the menu width
                        maxHeight: "350px",
                      }),
                    }}
                  />
                </div>
              </div>
              <div>
                <button
                  className="button-33  ms-3 position-relative d-none"
                  style={{
                    border: "none",
                    padding: "10px 20px",
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={capacityPlan}
                >
                  Check availability
                  <div class="icon icon-round d-flex align-items-center border justify-content-center">
                    <BsCheckCircleFill className="text-blue"></BsCheckCircleFill>
                  </div>
                </button>
              </div>
            </div>
            <Container fluid className="d-flex pb-4 ">
              <Split
                direction="horizontal"
                sizes={[leftWidth, 100 - leftWidth]}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  transition: "all 0.3s ease-in-out",
                }}
              >
                <div className="card rounded-0 mx-2 mb-0 shadow">
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "300px" }} // Set a fixed height for proper centering
                    >
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    renderTable(leftData)
                  )}
                </div>
              </Split>
            </Container>
          </div>
        </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="fs-6 d-flex">
              <VscVmActive className="fs-6 me-2 text-primary" />{" "}
              <p className="mb-0">Request to Increase Quota</p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table bordered hover>
              <thead className="tablebg">
                <tr>
                  <th className="text-center p-2">Family</th>
                  <th className="text-center p-2">New limit</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center align-middle">
                    {selectedFamilyRequest}
                  </td>
                  {/* <td
                    className="text-center align-middle"
                    style={{ width: "15%" }}
                  >{`${targetUsage} of ${targetAvailableCors}`}</td> */}
                  <td style={{ width: "36%" }}>
                    <input
                      type="number"
                      min="0"
                      className="form-control form-control-sm"
                      value={limitRequest}
                      onChange={handleLimitChange}
                      placeholder={`Need ${
                        Number(prevUsage) +
                        Number(targetUsage) -
                        Number(targetAvailableCors)
                      } vCPUs`}
                      aria-label="Limit Range Input"
                    />
                    {errorMessage && (
                      <small className="text-danger">{errorMessage}</small>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div className="mt-3">
              <label>{targetAvailableCors} vCPUs</label>
              <div className="d-flex align-items-center">
                <ProgressBar
                  now={progressValue}
                  className="flex-grow-1 bg-danger"
                  style={{ height: "10px" }}
                />
                <span className="ms-2">{totalLimit} vCPUs</span>{" "}
                {/* Total limit displayed on the right */}
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 font-circle text-secondary">Source</p>
                <p className="mb-0 font-circle text-primary">Target</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" onClick={handleClose}>
              Close
            </Button> */}
            <Button
              onClick={handleRequestClick}
              className="button-start text-center text-white"
            >
              Request
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </>
  );
};

export default Capacity;
